import type {
    UpdateCommerceCheckoutContactRequest,
    UpdateCommerceCheckoutContactResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const updateCommerceCheckoutContactOperation = defineCommerceOperation<
    UpdateCommerceCheckoutContactRequest,
    UpdateCommerceCheckoutContactResponse
>("commerce.checkout.update-contact");
